export const backgroundImages = [
  {
    url: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    title: 'Advanced Medical Technology',
    subtitle: 'State-of-the-art equipment for precise diagnosis',
  },
  {
    url: 'https://images.unsplash.com/photo-1584982751601-97dcc096659c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80',
    title: 'Expert Medical Team',
    subtitle: 'Experienced professionals dedicated to your health',
  },
  {
    url: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=2080&q=80',
    title: 'Comprehensive Patient Care',
    subtitle: 'Personalized treatment plans for every patient',
  },
];
